import DOMPurify from "dompurify";
import cn from "classnames";
import { usePlacementAnimation } from "../../../hooks/use-placement-animation";
import { SpecialOfferHeaderProps } from "./types";
import styles from "./styles.scss";

export const SpecialOfferHeader = ({
  settings,
  dataTestId = "special-offer-header",
  onClick,
}: SpecialOfferHeaderProps) => {
  const { text, background, textColor } = settings;

  const { placementRef: headerRef, mouseMoveHandler } =
    usePlacementAnimation(background);

  return (
    <div
      ref={headerRef}
      onMouseMove={mouseMoveHandler}
      className={styles["special-offer-header"]}
      style={{ background: background }}
      onClick={onClick}
      data-test-id={dataTestId}
    >
      <p
        dangerouslySetInnerHTML={{
          __html: DOMPurify.sanitize(text ?? ""),
        }}
        className={cn(styles["special-offer-header-text"])}
        style={{ color: textColor }}
      />
    </div>
  );
};
